import { useState, useEffect } from 'react';
import moment, { Moment } from 'moment';

import { SingleDatePickerWithCollapsibleCalendar } from 'ui/datePicker';
import { displayDate, ES_DATE_FORMAT } from 'utils/date';
import { isMilliseconds } from 'modules/workflows/utils/queryStringUtils';

type FilterDateValueInputProps = {
  onChange: (value: string) => void;
  value: string;
  isDisabled?: boolean;
  hasError?: boolean;
};

export const getDisplayDate = (date: string | Moment) => displayDate(date, ES_DATE_FORMAT);
const checkIfValid = (val: any) => moment(val).isValid();

export const FilterDateValueInput = ({
  onChange,
  value,
  isDisabled = false,
  hasError = false,
}: FilterDateValueInputProps) => {
  const [validVal, setValue] = useState<any>(!value && moment());

  useEffect(() => {
    if (value) {
      let momentValue = moment(value);
      // Classic sends back time in ms so we only need to handle
      // this the first time the component is set
      // todo: consider removing once Classic is long gone
      if (!validVal) {
        const valueToNumber = Number(value);
        if (isMilliseconds(valueToNumber)) momentValue = moment(valueToNumber);
      }

      const validatedValue = checkIfValid(momentValue)
        ? moment(momentValue, ES_DATE_FORMAT)
        : value;
      setValue(validatedValue);
    } else {
      // adds a default value of today for the date input
      onChange(getDisplayDate(moment()));
    }
  }, [value]);

  const onDateChange = (date: string | Moment) => {
    if (checkIfValid(date)) {
      onChange(getDisplayDate(date));
    } else if (typeof date === 'string') {
      onChange(date);
    }
  };

  if (!validVal) return null;
  return (
    <SingleDatePickerWithCollapsibleCalendar
      canClearDate={false}
      date={validVal}
      onDateChange={onDateChange}
      horizontalAlignment="right"
      showTime
      hasError={hasError}
      isDisabled={isDisabled}
    />
  );
};
